import { LAB_CON_CONCEPTS_ITEM } from './lab-con-concepts.js'

/** @type {import('../help-index.js').HelpScreen} */
export const LAB_CON_HELP = {
  screenId: 'lab-con',
  label: 'Conceptos',
  navPath: 'Laboral → Conceptos',
  keywords: [
    'concepto', 'haber', 'descuento', 'remunerativo', 'sac', 'aportes', 'liquidación', 'afip', 'lsd',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Haberes y descuentos de liquidación: forma de cálculo, códigos LSD/AFIP y asignación a todos los empleados o por legajo.',
  sidebarItems: [LAB_CON_CONCEPTS_ITEM],
}
